import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  Label,
  Row,
} from "reactstrap";
import { Link, useHistory, useLocation } from "react-router-dom";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getAcceptanceActs } from "services/apiSupply";
import useQuery from "utils/useQuery";
import { AcceptanceActsTable } from "features/AcceptanceActs/AcceptanceActsTable";
import { Pagination } from "components/Pagination";
import { priceFormat } from "utils/format";
import { SelectProvider } from "components/SelectProvider";
import { MySpinner } from "components/MySpinner";

import "./acceptanceActs.scss";

export const AcceptanceActsPage = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const query = useQuery(useLocation);
  const [acceptanceActs, setAcceptanceActs] = useState([]);
  const [acceptanceActsCount, setAcceptanceActsCount] = useState(0);
  const [acceptanceActsSumm, setAcceptanceActsSumm] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(query.get("search") || "");
  const [number, setNumber] = useState(query.get("number") || "");

  const [provider, setProvider] = useState(
    query.get("provider")
      ? { label: query.get("providerName"), value: query.get("provider") }
      : null
  );

  const [isShowReset, setIsShowReset] = useState(false);

  const [currentPage, setCurrentPage] = useState(
    query.get("page") ? Number(query.get("page")) : 1
  );
  const getPageSize = localStorage.getItem("pageSize") ? JSON.parse(localStorage.getItem("pageSize")) : {};
  const [pageSize, setPageSize] = useState(getPageSize[pathname] || 10);

  useEffect(() => {
    const url = new URLSearchParams();
    if (currentPage !== 1) {
      url.append("page", currentPage);
    }

    if (search) {
      url.append("search", search);
    }

    if (number) {
      url.append("number", number);
    }

    if (provider?.value) {
      url.append("provider", provider.value);
      url.append("providerName", provider.label);
    }

    if (url) {
      history.push(`${pathname}?${url}`);
    } else {
      history.push(pathname);
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, search, number, provider]);

  const getAndSetAcceptanceActs = () => {
    getAcceptanceActs({
      paginationCount: pageSize,
      paginationOffset: (currentPage - 1) * pageSize,
      search,
      number,
      provider: provider?.value,
    })
      .then((res) => {
        setAcceptanceActs(res.items);
        setAcceptanceActsCount(res.totalItems);
        setAcceptanceActsSumm(res.totalSumm);
      })
      .catch((e) => console.error(e))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    getAndSetAcceptanceActs();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize]);

  const isSearch = () => {
    if (search || number || provider) {
      return true;
    }
    return false;
  };

  const searchHandler = () => {
    if (!isSearch()) return;
    if (currentPage !== 1) {
      setCurrentPage(1);
      return;
    }
    setLoading(true);
    getAndSetAcceptanceActs();
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
      searchHandler();
    }
  };

  useEffect(() => {
    setIsShowReset(isSearch());
    if (!isSearch()) {
      setLoading(true);
      getAndSetAcceptanceActs();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, number, provider]);

  const resetFilter = () => {
    setSearch("");
    setNumber("");
    setProvider(null);
  };

  const numberHandler = (e) => {
    setNumber(e.target.value.replace(/[^+\d]/g, ""));
  };

  return (
    <Container fluid className="p-0 corr-orders">
      {loading && <MySpinner overlay />}
      <Card className="mb-0 filter">
        <CardBody>
          <h1 className="h3 mb-3">Акты приемки товара на хранение</h1>

          <Form className="mb-3">
            <Row>
              <Col md={2}>
                <Label>Номер</Label>
                <Input
                  name="number"
                  placeholder="По номеру"
                  value={number}
                  onChange={numberHandler}
                  onKeyPress={handleKeypress}
                />
              </Col>
              <Col md={2}>
                <Label>Артикул</Label>
                <Input
                  name="search"
                  placeholder="По артикулу"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyPress={handleKeypress}
                />
              </Col>
              <Col>
                <Label>Поставщик</Label>
                <SelectProvider provider={provider} setProvider={setProvider} />
              </Col>

              <Col>
                <InputGroup className="with-label">
                  {isShowReset && (
                    <Button color="danger" onClick={() => resetFilter()}>
                      <FontAwesomeIcon icon={faWindowClose} />
                    </Button>
                  )}
                  <Button
                    color="primary"
                    onClick={searchHandler}
                    className="button-wide"
                  >
                    Поиск
                  </Button>
                </InputGroup>
              </Col>
            </Row>

            <Row>
              <Col md={2}>
                Документов: {acceptanceActsCount} на сумму{" "}
                {priceFormat(parseFloat(acceptanceActsSumm))}
              </Col>
            </Row>
          </Form>
          <Row>
            <Col md="2">
              <Link
                to={`/receipt/acceptanceActs/new`}
                color="primary"
                className="button-wide btn btn-primary"
              >
                Добавить
              </Link>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <div>
        <AcceptanceActsTable acceptanceActs={acceptanceActs} />

        <Card>
          <CardBody>
            <Pagination
              totalCount={acceptanceActsCount}
              currentPage={currentPage}
              pageSize={pageSize}
              setCurrentPage={setCurrentPage}
              onChangePageSize={setPageSize}
            />
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};
